import { LockClosedIcon, PlayCircleIcon } from "@heroicons/react/20/solid";
import { cn } from "@punchup/utils/cn";
import { formatPriceFromCents } from "@punchup/utils/formatPriceFromCents";
import { Product } from "@punchup/data/legacy";

interface LockedUnlockedOverlayProps {
  unlocked: boolean;
  product: Product | null;
  specialRequiresPurchase: boolean;
  specialRequiresSubscription: boolean;
  label?: string;
}

export default function LockedUnlockedOverlay({
  unlocked,
  product,
  specialRequiresPurchase,
  specialRequiresSubscription,
}: LockedUnlockedOverlayProps) {
  return (
    <span
      className={cn(
        "invisible absolute group-hover:visible rounded-lg transition-all duration-150 group-hover:ease-in flex items-center justify-center",
        unlocked ? "w-full h-full" : "w-fit h-fit top-3 right-3"
      )}
    >
      {unlocked ? (
        <div className="flex items-center justify-center w-full h-full rounded-lg bg-neutral-300 bg-opacity-30">
          <PlayCircleIcon className="w-12 h-12 text-white" aria-hidden="true" />
          <span className="pl-1 text-2xl text-white">Watch</span>{" "}
        </div>
      ) : (
        <div
          className={cn(
            unlocked
              ? "flex items-center justify-center bg-neutral-300 bg-opacity-30 w-full h-full rounded-lg"
              : "p-[8px] rounded-3xl bg-white flex gap-x-0.5"
          )}
        >
          <span className="h-full px-1 font-bold text-primary">
            {specialRequiresPurchase && !product
              ? "Loading..."
              : specialRequiresPurchase && product && product.is_flex_price
                ? "Pay What You Want"
                : specialRequiresPurchase && product && product.price > 0
                  ? `${formatPriceFromCents(product.price)}`
                  : !specialRequiresSubscription
                    ? " Free!"
                    : " Subscribe"}
          </span>
          <LockClosedIcon
            className="h-5 w-5 text-primary mt-[1px]"
            aria-hidden="true"
          />
        </div>
      )}
    </span>
  );
}
